import { useQuery } from '@tanstack/react-query'
import { cartoesApi } from '../../api/endpoints'
import { Select } from '../../components/ui/Input'
import { formatMoney, formatDate } from '../../lib/utils'

const mesAno = (mes: number, ano: number) => `${String(mes).padStart(2, '0')}/${ano}`
const MAX_LISTA = 5

/** Onde entra a compra feita no dia do fechamento (campo compraNoFechamentoNaFaturaQueFecha do cartão). */
export function SeletorFechamento({ valor, onChange }: { valor: boolean; onChange: (v: boolean) => void }) {
  return (
    <div className="sm:col-span-2">
      <Select
        label="Compras no dia do fechamento entram"
        value={valor ? 'que-fecha' : 'seguinte'}
        onChange={(e) => onChange(e.target.value === 'que-fecha')}
      >
        <option value="seguinte">Na fatura seguinte (padrão)</option>
        <option value="que-fecha">Na fatura que fecha</option>
      </Select>
      <p className="mt-1 text-2xs text-muted">Confira no extrato do banco: se a fatura vai de 06/09 a 05/10 e fecha dia 05, a compra do dia 05 entra na fatura que fecha.</p>
    </div>
  )
}

/** Ao editar: mostra o que mudaria de fatura com a nova regra. Só informa; as compras já lançadas não são movidas. */
export function PreviaFechamento({ cartaoId, novoValor }: { cartaoId: string; novoValor: boolean }) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['cartao-fechamento-previa', cartaoId, novoValor],
    queryFn: () => cartoesApi.fechamentoPrevia(cartaoId, novoValor),
    retry: false,
  })
  if (isLoading) return <p className="text-13 text-muted sm:col-span-2">Conferindo as compras do dia do fechamento…</p>
  // Sem a prévia (API antiga ou falha) o salvar segue normal.
  if (isError || !data || data.quantidade === 0) return null
  const lista = data.compras.slice(0, MAX_LISTA)
  return (
    <div className="rounded border border-warning/50 bg-warning/10 p-3 text-13 sm:col-span-2" role="note">
      <p className="text-warning">
        {data.quantidade} {data.quantidade === 1 ? 'compra' : 'compras'} ({formatMoney(data.valorTotal)}) ficariam em outra fatura.
        {' '}Elas NÃO serão movidas: só as próximas compras seguem a nova regra.
      </p>
      <ul className="mt-2 space-y-1 text-muted">
        {lista.map((c) => (
          <li key={c.id} className="flex flex-wrap justify-between gap-x-3">
            <span className="min-w-0 truncate text-white">{c.descricao} · {formatDate(c.data)}</span>
            <span className="whitespace-nowrap">{mesAno(c.faturaAtualMes, c.faturaAtualAno)} → {mesAno(c.faturaNovaMes, c.faturaNovaAno)}</span>
          </li>
        ))}
      </ul>
      {data.compras.length > lista.length && <p className="mt-1 text-2xs text-muted">e mais {data.compras.length - lista.length}.</p>}
    </div>
  )
}
